export default "__VITE_ASSET__DE0HYx6k__"